var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasViewPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _vm.$store.getters.isAdmin
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("SMS.agentId")) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "filter-item",
                                    attrs: {
                                      placeholder: _vm.$t("SMS.pleaseChoose"),
                                      clearable: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.listQuery.agentId,
                                      callback: function($$v) {
                                        _vm.$set(_vm.listQuery, "agentId", $$v)
                                      },
                                      expression: "listQuery.agentId"
                                    }
                                  },
                                  _vm._l(_vm.agentOption, function(item) {
                                    return _c("el-option", {
                                      key: item.agentId,
                                      attrs: {
                                        label: item.agentName,
                                        value: item.agentId
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("SMS.organizationName")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.listQuery.organizationName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.listQuery,
                                      "organizationName",
                                      $$v
                                    )
                                  },
                                  expression: "listQuery.organizationName"
                                }
                              },
                              _vm._l(_vm.organizationNameOption, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.organizationCode,
                                  attrs: {
                                    label: item.organizationName,
                                    value: item.organizationName
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("SMS.organizationCode")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("SMS.pleaseEnterText")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleFilter($event)
                                }
                              },
                              model: {
                                value: _vm.listQuery.organizationCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.listQuery,
                                    "organizationCode",
                                    $$v
                                  )
                                },
                                expression: "listQuery.organizationCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.$store.getters.isAdmin
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("SMS.description")) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "filter-item",
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("SMS.pleaseEnterText")
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.handleFilter($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.listQuery.description,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.listQuery,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression: "listQuery.description"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("SMS.status")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.listQuery.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "status", $$v)
                                  },
                                  expression: "listQuery.status"
                                }
                              },
                              _vm._l(_vm.statusOptions, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.$store.getters.isAdmin
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("SMS.approveState")) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "filter-item",
                                    attrs: {
                                      placeholder: _vm.$t("SMS.pleaseChoose"),
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.listQuery.approveStateCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "approveStateCode",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.approveStateCode"
                                    }
                                  },
                                  _vm._l(_vm.authenticateOptions, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.display_name,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "div",
                    { staticClass: "otherActions" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("approve"),
                              expression: "hasPermissionEx('approve')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "success",
                            icon: "el-icon-success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleApproveSuccess("approve")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.approve")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("approve"),
                              expression: "hasPermissionEx('approve')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "danger",
                            icon: "el-icon-error"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleApproveFail("reject")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.reject")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("export"),
                              expression: "hasPermissionEx('export')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-message"
                          },
                          on: { click: _vm.handleExportActiveUserReport }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("SMS.exportActiveUserReportText")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "addEditOrDelete" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasAddPermission,
                              expression: "hasAddPermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "success",
                            icon: "el-icon-plus"
                          },
                          on: { click: _vm.handleCreate }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.add")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasDeletePermission,
                              expression: "hasDeletePermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "danger",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleDelete("delete")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.cancelUser")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasViewPermission,
                        expression: "hasViewPermission"
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf,
                      "highlight-current-row": ""
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        label: "",
                        align: "center",
                        width: "45",
                        fixed: ""
                      }
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.agentId"),
                            align: "center",
                            fixed: "",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: _vm.convertAgentNameByAgentId(
                                            scope.row.agentId
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.convertAgentNameByAgentId(
                                                  scope.row.agentId
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1392507550
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.organizationName"),
                        align: "center",
                        fixed: "",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.organizationName
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.organizationName))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.organizationCode"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.organizationCode
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.organizationCode))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.description"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("md")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: scope.row.description
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.description)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1512624094
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.totalRechargeYuan"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.processAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.processAmount))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.amountAvailableYuan"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.processAvailableAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.processAvailableAmount)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.frozenAmount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.processFrozenAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.processFrozenAmount)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.uncreditedAmount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.processUncreditedAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processUncreditedAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.status"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertStatusName(
                                      scope.row.status
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertStatusName(
                                            scope.row.status
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.approveState"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: _vm.convertAuthenticateName(
                                            scope.row.approveStateCode
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.convertAuthenticateName(
                                                    scope.row.approveStateCode
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4113889470
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("common.createTimeText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.createDate
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.createDate))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.operating"),
                        width: "520",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasUpdatePermission,
                                      expression: "hasUpdatePermission"
                                    }
                                  ],
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-edit",
                                    size: "mini",
                                    round: _vm.$store.getters.roundConf,
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdate(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.edit")) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("costUpdates"),
                                      expression:
                                        "hasPermissionEx('costUpdates')"
                                    }
                                  ],
                                  attrs: {
                                    type: "warning",
                                    size: "mini",
                                    icon: "el-icon-edit-outline",
                                    round: _vm.$store.getters.roundConf,
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCost(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.cost")) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", { attrs: { src: "", alt: "" } }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("delete"),
                                      expression: "hasPermissionEx('delete')"
                                    }
                                  ],
                                  attrs: {
                                    type: "danger",
                                    icon: "el-icon-delete",
                                    size: "mini",
                                    round: _vm.$store.getters.roundConf,
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleInvalid(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.invalid")) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("exportApi"),
                                      expression: "hasPermissionEx('exportApi')"
                                    }
                                  ],
                                  attrs: {
                                    type: "success",
                                    icon: "el-icon-delete",
                                    size: "mini",
                                    round: _vm.$store.getters.roundConf,
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadApiDetail(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("organization.viewOrgDetailText")
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasViewPermission,
                      expression: "hasViewPermission"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.listQuery.pageNum,
                    limit: _vm.listQuery.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.listQuery, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.listQuery, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    id: "dialog",
                    visible: _vm.dialogFormVisible,
                    width: "700px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogFormVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card" },
                    [
                      _c("div", { staticClass: "card-title" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.textMap[_vm.dialogType]) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "close" }, [
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function($event) {
                                _vm.dialogFormVisible = false
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.formLoading,
                              expression: "formLoading"
                            }
                          ],
                          ref: "dataForm",
                          attrs: {
                            rules: _vm.rules,
                            model: _vm.formTemp,
                            "label-position": "left",
                            "label-width": "220px"
                          }
                        },
                        [
                          _vm.$store.getters.isAdmin
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SMS.agentId"),
                                    prop: "agentId"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "option.pleaseChoose"
                                        ),
                                        clearable: "",
                                        disabled: _vm.dialogType === "update",
                                        filterable: ""
                                      },
                                      model: {
                                        value: _vm.formTemp.agentId,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formTemp, "agentId", $$v)
                                        },
                                        expression: "formTemp.agentId"
                                      }
                                    },
                                    _vm._l(_vm.agentOption, function(item) {
                                      return _c("el-option", {
                                        key: item.agentId,
                                        attrs: {
                                          label: item.agentName,
                                          value: item.agentId
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.organizationName"),
                                prop: "organizationName"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formTemp.organizationName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formTemp,
                                      "organizationName",
                                      $$v
                                    )
                                  },
                                  expression: "formTemp.organizationName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.dialogType === "update"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SMS.organizationCode"),
                                    prop: "organizationCode"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.formTemp.organizationCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formTemp,
                                          "organizationCode",
                                          $$v
                                        )
                                      },
                                      expression: "formTemp.organizationCode"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dialogType === "create"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SMS.username"),
                                    prop: "userAccount"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.formTemp.userAccount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formTemp,
                                          "userAccount",
                                          $$v
                                        )
                                      },
                                      expression: "formTemp.userAccount"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dialogType === "create"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SMS.password"),
                                    prop: "userPassword"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "password",
                                      "show-password": ""
                                    },
                                    model: {
                                      value: _vm.formTemp.userPassword,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formTemp,
                                          "userPassword",
                                          $$v
                                        )
                                      },
                                      expression: "formTemp.userPassword"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dialogType === "create"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SMS.confirmPassword"),
                                    prop: "checkPassword"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "password",
                                      "show-password": ""
                                    },
                                    model: {
                                      value: _vm.formTemp.checkPassword,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formTemp,
                                          "checkPassword",
                                          $$v
                                        )
                                      },
                                      expression: "formTemp.checkPassword"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dialogType === "create"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SMS.payPassword"),
                                    prop: "payPassword"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "password",
                                      "show-password": ""
                                    },
                                    model: {
                                      value: _vm.formTemp.payPassword,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formTemp,
                                          "payPassword",
                                          $$v
                                        )
                                      },
                                      expression: "formTemp.payPassword"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.contactPerson"),
                                prop: "contact"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formTemp.contact,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "contact", $$v)
                                  },
                                  expression: "formTemp.contact"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.contactNumber"),
                                prop: "contactMobile"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  oninput:
                                    "javascript:this.value=this.value.replace(/\\D/g,'')"
                                },
                                model: {
                                  value: _vm.formTemp.contactMobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "contactMobile", $$v)
                                  },
                                  expression: "formTemp.contactMobile"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.dialogType === "update"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SMS.status"),
                                    prop: "status"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: _vm.$t(
                                          "option.pleaseChoose"
                                        )
                                      },
                                      model: {
                                        value: _vm.formTemp.status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formTemp, "status", $$v)
                                        },
                                        expression: "formTemp.status"
                                      }
                                    },
                                    _vm._l(_vm.statusOptions, function(option) {
                                      return _c("el-option", {
                                        key: option.key,
                                        attrs: {
                                          label: option.display_name,
                                          value: option.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.enterpriseMailbox"),
                                prop: "email"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formTemp.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "email", $$v)
                                  },
                                  expression: "formTemp.email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.companyAddress"),
                                prop: "address"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formTemp.address,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "address", $$v)
                                  },
                                  expression: "formTemp.address"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.corporateWebsite"),
                                prop: "webUrl"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formTemp.webUrl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "webUrl", $$v)
                                  },
                                  expression: "formTemp.webUrl"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.bindIP"),
                                prop: "bindIp"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formTemp.bindIp,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "bindIp", $$v)
                                  },
                                  expression: "formTemp.bindIp"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.description"),
                                prop: "description"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formTemp.description,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "description", $$v)
                                  },
                                  expression: "formTemp.description"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "confirm-button" },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialogFormVisible = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.cancel")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.formLoading,
                                  expression: "formLoading"
                                }
                              ],
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.dialogType === "create"
                                    ? _vm.doCreateData()
                                    : _vm.doUpdateData()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.confirm")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    id: "dialog",
                    visible: _vm.dialogInvalidVisible,
                    width: "700px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogInvalidVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card" },
                    [
                      _c("div", { staticClass: "card-title" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.textMap[_vm.dialogType]) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "close" }, [
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function($event) {
                                _vm.dialogInvalidVisible = false
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "dataInvalid",
                          attrs: {
                            rules: _vm.invalidRules,
                            model: _vm.invalidTemp,
                            "label-position": "left",
                            "label-width": "220px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.organizationCode"),
                                prop: "organizationCode"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.invalidTemp.organizationCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.invalidTemp,
                                      "organizationCode",
                                      $$v
                                    )
                                  },
                                  expression: "invalidTemp.organizationCode"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.organizationName"),
                                prop: "organizationName"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.invalidTemp.organizationName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.invalidTemp,
                                      "organizationName",
                                      $$v
                                    )
                                  },
                                  expression: "invalidTemp.organizationName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.amountAvailableYuan"),
                                prop: "availableAmount"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", type: "number" },
                                model: {
                                  value: _vm.invalidTemp.processAvailableAmount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.invalidTemp,
                                      "processAvailableAmount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "invalidTemp.processAvailableAmount"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.balanceProcessing"),
                                prop: "orgAmountHandle"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-item",
                                  attrs: {
                                    placeholder: _vm.$t("option.pleaseChoose"),
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.invalidTemp.orgAmountHandle,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.invalidTemp,
                                        "orgAmountHandle",
                                        $$v
                                      )
                                    },
                                    expression: "invalidTemp.orgAmountHandle"
                                  }
                                },
                                _vm._l(_vm.balanceProcessingOption, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.display_name,
                                      value: item.key
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "confirm-button" },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialogInvalidVisible = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.cancel")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.doInvalidData()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.confirm")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    id: "copyCostdialog",
                    visible: _vm.copyCostDialogVisible,
                    width: "700px",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.copyCostDialogVisible = $event
                    },
                    closed: function($event) {
                      _vm.copyCostDialogVisible = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card" },
                    [
                      _c("div", { staticClass: "card-title" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("organization.copyOrganizationCostText")
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "close" }, [
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function($event) {
                                _vm.copyCostDialogVisible = false
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "copyCost",
                          attrs: {
                            model: _vm.copyCostParameter,
                            "label-width": "220px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "organization.sourceOrganizationNameText"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-item",
                                  attrs: {
                                    placeholder: _vm.$t("option.pleaseChoose"),
                                    clearable: "",
                                    filterable: ""
                                  },
                                  model: {
                                    value:
                                      _vm.copyCostParameter
                                        .sourceOrganizationCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.copyCostParameter,
                                        "sourceOrganizationCode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "copyCostParameter.sourceOrganizationCode"
                                  }
                                },
                                _vm._l(_vm.organizationNameOption, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.organizationCode,
                                    attrs: {
                                      label: item.organizationName,
                                      value: item.organizationCode
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "organization.targetOrganizationNameText"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-item",
                                  attrs: {
                                    placeholder: _vm.$t("option.pleaseChoose"),
                                    multiple: "",
                                    clearable: "",
                                    filterable: ""
                                  },
                                  model: {
                                    value:
                                      _vm.copyCostParameter
                                        .targetOrganizationCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.copyCostParameter,
                                        "targetOrganizationCode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "copyCostParameter.targetOrganizationCode"
                                  }
                                },
                                _vm._l(_vm.organizationNameOption, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.organizationCode,
                                    attrs: {
                                      label: item.organizationName,
                                      value: item.organizationCode
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("common.remark") } },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                 " +
                                    _vm._s(
                                      _vm.$t(
                                        "warningMessage.copyOrganizationCostRemark"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "confirm-button" },
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.handleResetCopyCost } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.reset")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleCopyCost }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.submit")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    id: "changeAgentDialog",
                    visible: _vm.changeAgentDialogVisible,
                    width: "700px",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.changeAgentDialogVisible = $event
                    },
                    closed: function($event) {
                      _vm.changeAgentDialogVisible = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card" },
                    [
                      _c("div", { staticClass: "card-title" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("organization.changeAgentText")) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "close" }, [
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function($event) {
                                _vm.changeAgentDialogVisible = false
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "copyCost",
                          attrs: {
                            model: _vm.changeAgentParameter,
                            "label-width": "220px"
                          }
                        },
                        [
                          false
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "organization.originAgentNameText"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "option.pleaseChoose"
                                        ),
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.changeAgentParameter
                                            .originAgentId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.changeAgentParameter,
                                            "originAgentId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "changeAgentParameter.originAgentId"
                                      }
                                    },
                                    _vm._l(_vm.agentOption, function(item) {
                                      return _c("el-option", {
                                        key: item.agentId,
                                        attrs: {
                                          label: item.agentName,
                                          value: item.agentId
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "organization.targetOrganizationNameText"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-item",
                                  attrs: {
                                    placeholder: _vm.$t("option.pleaseChoose"),
                                    multiple: "",
                                    clearable: "",
                                    filterable: ""
                                  },
                                  model: {
                                    value:
                                      _vm.changeAgentParameter
                                        .targetOrganizationCodes,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.changeAgentParameter,
                                        "targetOrganizationCodes",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "changeAgentParameter.targetOrganizationCodes"
                                  }
                                },
                                _vm._l(_vm.organizationNameOption, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.organizationCode,
                                    attrs: {
                                      label: item.organizationName,
                                      value: item.organizationCode
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "organization.targetAgentNameText"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-item",
                                  attrs: {
                                    placeholder: _vm.$t("option.pleaseChoose"),
                                    clearable: "",
                                    filterable: ""
                                  },
                                  model: {
                                    value:
                                      _vm.changeAgentParameter.targetAgentId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.changeAgentParameter,
                                        "targetAgentId",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "changeAgentParameter.targetAgentId"
                                  }
                                },
                                _vm._l(_vm.agentOption, function(item) {
                                  return _c("el-option", {
                                    key: item.agentId,
                                    attrs: {
                                      label: item.agentName,
                                      value: item.agentId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("common.remark") } },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                 " +
                                    _vm._s(
                                      _vm.$t("warningMessage.changeAgentRemark")
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "confirm-button" },
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.handleResetChangeAgent } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.reset")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleChangeAgent }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.submit")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    id: "orgDetailDialog",
                    visible: _vm.orgDetailDialogVisible,
                    width: "700px",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.orgDetailDialogVisible = $event
                    },
                    closed: function($event) {
                      _vm.orgDetailDialogVisible = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card" },
                    [
                      _c("div", { staticClass: "card-title" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("dashboard.merchant.companyInformation")
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "close" }, [
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function($event) {
                                _vm.orgDetailDialogVisible = false
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "orgDetail",
                          attrs: {
                            model: _vm.orgDetail,
                            "label-width": "220px"
                          }
                        },
                        [
                          _vm.orgDetail.HTTPDetail
                            ? _c(
                                "div",
                                [
                                  _vm.orgDetail.HTTPDetail.orgCode
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.organizationCode"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.HTTPDetail.orgCode
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.HTTPDetail.md5Key
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.md5Key"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.HTTPDetail.md5Key
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.HTTPDetail.httpApi
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.HTTPAPIText"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.HTTPDetail.httpApi
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.HTTPDetail.httpApiDocLink
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.goToDocs"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.HTTPDetail
                                                  .httpApiDocLink
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.orgDetail.SMPPDetail
                            ? _c(
                                "div",
                                [
                                  _vm.orgDetail.SMPPDetail.orgCode
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.organizationCode"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.SMPPDetail.orgCode
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.SMPPDetail.md5Key
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.md5Key"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.SMPPDetail.md5Key
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.SMPPDetail.systemId
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.accessNumber"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.SMPPDetail
                                                  .systemId
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.SMPPDetail.password
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.accessCode"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.SMPPDetail
                                                  .password
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.SMPPDetail.channelLine
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.numberOfConnections"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.SMPPDetail
                                                  .channelLine
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.SMPPDetail.channelLimit
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.channelRate"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.SMPPDetail
                                                  .channelLimit
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.orgDetail.SMPPDetail.smppApi
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "dashboard.merchant.SMPPAPIText"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.orgDetail.SMPPDetail.smppApi
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }